import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import type { TenantSummary } from '@/providers/tenant-context';

/** Свойства выбора площадки на странице согласия. */
export interface TenantChoiceProps {
  tenants: TenantSummary[];
  value: string;
  onChange: (slug: string) => void;
  disabled: boolean;
}

/**
 * Выбор площадки, на которую выпускается доступ ИИ-клиента.
 * Показывается только админу с несколькими площадками; одна подключённая площадка — один клиент.
 */
export function TenantChoice({ tenants, value, onChange, disabled }: TenantChoiceProps) {
  return (
    <div className="space-y-2 rounded-md border p-3">
      <p className="text-sm font-medium">Площадка</p>
      <p className="text-sm text-muted-foreground">
        Клиент будет работать с данными выбранной площадки. Для второй площадки подключите клиента ещё раз.
      </p>
      <RadioGroup value={value} onValueChange={onChange} disabled={disabled} className="gap-1">
        {tenants.map((tenant) => (
          <Label
            key={tenant.slug}
            htmlFor={`mcp-consent-tenant-${tenant.slug}`}
            className="flex min-h-11 cursor-pointer items-center gap-3 rounded-md px-2 font-normal hover:bg-muted"
          >
            <RadioGroupItem value={tenant.slug} id={`mcp-consent-tenant-${tenant.slug}`} />
            <span className="text-sm">{tenant.name}</span>
            <span className="text-xs text-muted-foreground">{tenant.slug}</span>
          </Label>
        ))}
      </RadioGroup>
    </div>
  );
}
